module.exports = __webpack_public_path__ + "static/media/tabletbg.445286d3.png";